module.exports = __webpack_public_path__ + "static/media/banff-23.e6145753.jpg";